<template>
  <div v-if="!isLargeScreen">
    <Splide class="mx-auto sm:w-full lg:w-6/12"
            :options="sliderOptions" aria-label="Prodotti">
      <SplideSlide :key="action" v-for="action in actions" class=""
                   @click="navigateTo(`/cause-sociali/${action.slug}`)">

        <div class="btn rounded-box btn-primary p-3 h-fit" @click="emit('select',action)" :data-action-key="action.key"
             :class="activeKey === action.key ? 'active bg-white' : ''">
          <div class="flex items-center">
            <img :src="CDN_URL+action.icon" :alt="action.label" class="min-w-14 h-14 inline "/>
          </div>
        </div>
        <div class="text-sm text-white pt-3">
          {{ action.label }}
        </div>
      </SplideSlide>
    </Splide>
  </div>
  <div v-else>
    <div class="flex flex-wrap justify-center gap-3">
      <div :key="action" v-for="action in actions" class="" @click="navigateTo(`/cause-sociali/${action.slug}`)">
        <div class="btn rounded-box btn-primary p-3 h-fit" @click="emit('select',action)" :data-action-key="action.key"
             :class="activeKey === action.key ? 'active bg-white' : ''">
          <div class="flex items-center">
            <img :src="CDN_URL+action.icon" :alt="action.label" class="min-w-14 h-14 inline "/>
          </div>
        </div>
        <div class="text-sm text-white pt-3">
          {{ action.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import actions from "assets/models/categories.json";

import { useMediaQuery } from '@vueuse/core'
const isLargeScreen = useMediaQuery('(min-width: 768px)')
const {public: {CDN_URL}} = useRuntimeConfig();
const props = defineProps(['animate']);
const emit = defineEmits(['select']);
const sliderOptions = {
  start: 3,
  trimSpace: true,
  focus: 'center',
  clones: 0,
  pagination: false,
  rewind: false,
  arrows: false,
  autoHeight: true,
  autoWidth: true,
  gap: '1rem',
  perMove: 1,
  breakpoints: {
    perPage: 4,
    breakpoints: {
      640: {
        arrows: true,
        perPage: 2,
      },
    }
  }
}

const route = useRoute();
const activeKey = ref(false);

const checkActiveCategory = () => {
  activeKey.value = false;
  actions.forEach(action => {
    if (route.path === `/categoria/${action.key}`) {
      activeKey.value = action.key;
    }
  });
}
checkActiveCategory();
onMounted(async () => {
  watch(() => route.path, () => {
    checkActiveCategory();
  }, {deep: true})
})

</script>